import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LibSubContractorsDto } from './lib-sub-contractors-dto';

export class SubContractorsResponseModel extends GlobalResponseObject{
    data?: LibSubContractorsDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LibSubContractorsDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        // this.data = data;
    }
}
